/** @jsxImportSource @emotion/react */
import { css} from '@emotion/react'
import { Button, RightAlignedContainer } from '../../Utils/styledComponents'
import { PrintTemplate, ItemsTable } from '../../Utils/Templates/PrintTemplate'
import { usePrint } from '../../Utils/Templates/usePrint';
import { formatDate} from '../../Utils/ConvertDate';
import styled from "@emotion/styled/macro";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {config} from "../../../Helpers/env";
import {logoutErrorMessage} from "../../../Helpers/ErrorMessages";


const textWeight = css`
    font-weight:600;
`



const StyledContainer = styled(RightAlignedContainer)({
    marginBottom:'5px'
})

function JournalDetails(props) {
    const [journal, setJournal] = useState({date: "", details: [], journal_id: "", total_credit: 0, total_debit: 0})

    useEffect(() => {
        if (!props.journal_id) {
            return
        }
        axios.get(`${config.smsUrl}/accounting/ledger_transaction_details`, {params:{journal:+props.journal_id}})
        .then(res => {
            const data = res.data;
            const all_data = !data ? {} : data;
            const info = !all_data.data ? {} : all_data.data;
            setJournal({date:info.date, details:info.details, journal_id:info.journal_id, total_credit:info.total_credit, total_debit:info.total_debit})
        }).catch(e => {
            logoutErrorMessage(e, null, actions)
        })
    }, [props.journal_id]);

    const {componentRef, handlePrint,fontSize}  = usePrint(`Journal Report`)

    const headData = [{key:'account',value:'Account'}, {key:'description',value:'Description'},
        {key:'debit',value:'Debit'}, {key:'credit',value:'Credit'}]
  const patientDetails = (
      <tbody>
          <tr>
              <td><span>Journal#: </span> <span css={[textWeight]}>{journal.journal_id}</span></td>
              <td><span>Date: </span> <span css={[textWeight]}>{formatDate(journal.date)}
                </span> </td>

          </tr>
       
      </tbody>
  )
  const itemDetails = (
    <ItemsTable {...{headData}}>
      <tbody>
      {journal.details.map((item) => {
            return (
                <tr key={item.bill_id}>
                    <td><span>{item.accountname}</span></td>
                    <td><span>{item.description}</span></td>
                    <td><span>{item.debit}</span></td>
                    <td><span>{item.credit}</span></td>
                </tr>
            )
        })}
          <tr>
              <td colSpan={headData.length -1}  align='right'><span css={[textWeight]}>Total Credit</span></td>
              <td ><span css={[textWeight]}>{journal.total_credit}</span></td>
          </tr>
          <tr>
              <td colSpan={headData.length -1}  align='right' ><span css={[textWeight]}>Total Debit</span></td>
              <td><span css={[textWeight]}>{journal.total_debit}</span></td>
          </tr>
      </tbody>
    </ItemsTable>
  )
  return (
      <div>
            <StyledContainer>
              <Button variant='orange' onClick={handlePrint}>Print</Button>
            </StyledContainer>
                <div ref={componentRef} className="requisition-receipt">
                    <style>
                        {fontSize()}
                    </style>
                    <PrintTemplate title='Journal Report' {...{patientDetails,itemDetails}}/>
                </div>
      </div>
  )
}

export default JournalDetails